<div class="profile-section-item" [class.validation-error]="hasValidationErrors">
  <app-card>
    <div class="profile-section-item__content">
      <div class="profile-section-item__main">
        <h4 class="profile-section-item__title">
          {{ title }}
        </h4>
        <p class="profile-section-item__subtitle">{{ subtitle }}</p>
        <!-- Decorative proficiency meter; the subtitle already states the level
             textually, so this is hidden from screen readers. -->
        <div
          *ngIf="levelMeter"
          class="profile-section-item__level-meter"
          [ngClass]="'profile-section-item__level-meter--' + levelMeter.variant"
          aria-hidden="true">
          <span
            *ngFor="let seg of levelMeterSegments"
            class="profile-section-item__level-segment"
            [class.profile-section-item__level-segment--filled]="seg <= levelMeter.filled"></span>
        </div>
        <p *ngIf="documentName" class="profile-section-item__document">
          <i class="fas fa-file-alt"></i>
          {{ documentName }}
        </p>
        <!-- Validation error message -->
        <p *ngIf="hasValidationErrors && validationMessage" class="profile-section-item__validation-error">
          <i class="fas fa-exclamation-triangle"></i>
          {{ validationMessage }}
        </p>
      </div>
      <div class="profile-section-item__actions">
        <span *ngIf="hasAttachment" class="profile-section-item__badge document-badge">
          <i class="fas fa-file-alt"></i>
        </span>
        <!-- Removed saved status badge -->
        <!-- Show AI parsed badge only if needed -->
        <span *ngIf="isAiParsed && !showSaveButton && !hasValidationErrors" class="profile-section-item__badge ai-parsed-badge">
          {{ 'profile.profileSection.aiParsed' | transloco }}
        </span>
        <div class="profile-section-item__buttons">
          <app-button *ngIf="showSaveButton && isAiParsed" variant="outline" color="primary" size="sm" (btnClick)="onSave()" ariaLabel="Save">
            {{ 'profile.profileSection.save' | transloco }}
          </app-button>
          <!-- Edit button with different colors based on validation status -->
          <app-button
            *ngIf="showEditButton"
            variant="invisible"
            [color]="hasValidationErrors ? 'error' : 'secondary'"
            size="sm"
            [icon]="true"
            (btnClick)="onEdit()"
            ariaLabel="Edit">
            <i class="fas fa-pencil-alt"></i>
          </app-button>
          <app-button *ngIf="showDeleteButton" variant="invisible" color="secondary" size="sm" [icon]="true" (btnClick)="onDelete()" ariaLabel="Delete">
            <i class="fas fa-times"></i>
          </app-button>
        </div>
      </div>
    </div>
  </app-card>
</div>
